import { render, staticRenderFns } from "./common-table.vue?vue&type=template&id=4cc5acf1&scoped=true"
import script from "./common-table.vue?vue&type=script&lang=js"
export * from "./common-table.vue?vue&type=script&lang=js"
import style0 from "./common-table.vue?vue&type=style&index=0&id=4cc5acf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc5acf1",
  null
  
)

export default component.exports